<body>
  <section>
    <a href="javascript:" id="return-to-top"
      ><img
        src="https://img.icons8.com/metro/26/ffffff/sort-up.png"
        class="top"
        alt="sort-up"
    /></a>
    <div class="container-fluid section-second">
      <div class="row justify-content-center">
        <div class="col-lg-3 text-right">
          <div class="logo text-left">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-7)/assets/image/logo.png"
              alt="logo"
            />
          </div>
        </div>
        <div class="col-lg-7 text-right">
          <div class="social-img">
            <a
              href="https://onpassive.com/blog"
              target="_blank"
              rel="noopener"
              title="ONPASSIVE Blog"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-7)/assets/image/icon/blog.png"
                class="blogicon"
                alt="blog"
              />
            </a>
            <a
              href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Facebook"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-7)/assets/image/icon/fb.png"
                class="icon"
                alt="Facebook"
              />
            </a>
            <a
              href="https://twitter.com/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Twitter"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-7)/assets/image/icon/twitter.png"
                class="icon"
                alt="Twitter"
              />
            </a>
            <a
              href="https://www.instagram.com/ONPASSIVE/"
              target="_blank"
              rel="noopener"
              title="Instagram"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-7)/assets/image/icon/insta.png"
                class="icon"
                alt="Instagram"
              />
            </a>
            <a
              href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Youtube"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-7)/assets/image/icon/youtube.png"
                class="icon"
                alt="YouTube"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
              target="_blank"
              rel="noopener"
              title="LinkedIn"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-7)/assets/image/icon/in.png"
                class="icon"
                alt="LinkedIn"
              />
            </a>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-7">
            <div class="row justify-content-center">
              <div class="col-lg-8">
                <!--                <h1 class="font2 ml13">LAUNCHING </h1> -->
                <h1 class="font2">LAUNCHING</h1>
                <h2 class="font3">SOON</h2>
                <p class="font4">
                  Realize the potential of AI with modern-age marketing tools
                  hand-crafted by ONPASSIVE. Depending on the goals and needs of
                  the client, we offer comprehensive AI-tools to achieve those
                  goals and put that plan in motion. Launch your Internet
                  Marketing Business to a whole new level with the right tools.
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-7)/assets/image/cube.png"
              class="cube"
              alt="cube"
            />
            <div class="curcle">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <a href="#section2"
                  ><img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(jan-7)/assets/image/drop.png"
                    class="drop"
                    alt="drop"
                /></a>
              </div>
            </div>
          </div>
        </div>

        <div class="area">
          <ul class="circles">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main" id="section2">
      <div class="container-fluid section-third">
        <div class="row justify-content-center">
          <div class="col-lg-10 mt-5 text-center">
            <h1 class="ml14">
              <span class="text-wrapper">
                <span class="onpassive">ONPASSIVE</span>

                <span class="letters">Is Where You Register!</span>
              </span>
            </h1>
            <p class="font1">
              The biggest adventure of your life is to go behind your dreams. At
              ONPASSIVE, we guide you with a road-map to success and make sure
              that you are on the right track. With extensive AI marketing
              tools, we help to grow your business and prepare you for a
              revolution in the world of marketing.
            </p>
            <div class="row justify-content-center">
              <div class="col-lg-6">
                <div class="video-box">
                  <video
                    id="my-video"
                    class="
                      video-js video-size
                      w-100
                      h-auto
                      my-video-dimensions
                      shadow
                    "
                    controls
                    preload="auto"
                    poster="{{ myLinksS3URL }}images/Image0231.png"
                    data-setup="{}"
                    autoplay="true"
                    muted
                  >
                    <source
                      src="{{
                        myLinksS3URL
                      }}videos/Onpassive_launching_page_video2.mp4"
                      type="video/mp4"
                    />
                  </video>
                </div>
                <a
                  href="/registration/user?reg={{ userId }}"
                  name="regform"
                  target="_blank"
                  rel="noopener"
                  class="button fire mt-5"
                  >BECOME A FOUNDER NOW</a
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="copy-right text-center">
                &copy; 2022 ONPASSIVE - All Rights Reserved
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!----------------------------------------------------------------------------------------->
</body>
